import PathProgress from '../api/pathProgress';
import { applicationUpdate, applicationApiExecute } from './applicationActions';

export const updatePathProgress = applicationUpdate(PathProgress);
export const startPathProgress = applicationApiExecute(PathProgress.start);
